import { Log } from '../../shared/log';
const log = new Log('PaymentsService');

import 'rxjs/add/operator/toPromise';

import { Injectable } from '@angular/core';
import { Headers, RequestOptions } from '@angular/http';
import { AuthHttp } from 'angular2-jwt';
import { AppConfig } from '../../app.config';
import { IPaymentHistory } from '../../interfaces/IPaymentHistory';

@Injectable()
export class PaymentsService {
  private serverUrl = this.appConfig.getValue('endPoint');
  private paymentDetailsUrl = this.serverUrl + 'payments';

  private agencyNamesList = [
    {'servicename': 'Ambulance first aid training payments', 'agencyName': 'Department of Health'},
    {'servicename': 'BDM Birth certificate products', 'agencyName': 'Registry of Births, Deaths and Marriages'},
    {'servicename': 'BDM Birth certificate service', 'agencyName': 'Registry of Births, Deaths and Marriages'},
    {'servicename': 'Baby Capsule', 'agencyName': 'Queensland Ambulance Service'},
    {'servicename': 'Births, Deaths and Marriage Registry', 'agencyName': 'Department of Justice and Attorney-General'},
    {'servicename': 'Body corporate dispute', 'agencyName': 'Department of Justice and Attorney-General'},
    {'servicename': 'CITEC Access Services', 'agencyName': 'CITEC'},
    {'servicename': 'Commercial Activity Permit', 'agencyName': 'Commercial Activity Permit'},
    {'servicename': 'Dispute resolution branch training', 'agencyName': 'Department of Justice and Attorney-General'},
    {'servicename': 'Donations', 'agencyName': 'Donations'},
    {'servicename': 'Electronic Development Assessment', 'agencyName': 'Department of State Development, Infrastructure and Planning'},
    {'servicename': 'Environmentally Relevant Activities', 'agencyName': 'Environmental Protection Agency'},
    {'servicename': 'Fire safety course bookings', 'agencyName': 'Queensland Fire and Emergency Services'},
    {'servicename': 'Fisheries Infringement Notices', 'agencyName': 'Department of Agriculture, Fisheries and Forestry'},
    {'servicename': 'Fitness and physical ability assessments', 'agencyName': 'Public Safety Business Agency'},
    {'servicename': 'Forestry Act Infringement notice', 'agencyName': 'Department of Agriculture and Fisheries'},
    {'servicename': 'Gazette online payments', 'agencyName': 'Department of Housing and Public Works'},
    {'servicename': 'IA Parks NTP', 'agencyName': 'Department of National Parks, Recreation, Sport and Racing'},
    {'servicename': 'IA Parks SII', 'agencyName': 'Department of National Parks, Recreation, Sport and Racing'},
    {'servicename': 'IA Parks SII', 'agencyName': 'Department of National Parks, Recreation, Sport and Racing'},
    {'servicename': 'JAG Workplace Health and Safety', 'agencyName': 'Justice and Attorney-General'},
    {'servicename': 'Justice of the Peace shop', 'agencyName': 'Department of Justice and Attorney-General'},
    {'servicename': 'Local Government and Planning eda', 'agencyName': 'Queensland Building and Construction Commission'},
    {'servicename': 'Major project map sales', 'agencyName': 'Department of State Development, Infrastructure and Planning'},
    {'servicename': 'Music board examination sales', 'agencyName': 'Department of Education, Training and Employment'},
    {'servicename': 'Music board product sales', 'agencyName': 'Department of Education, Training and Employment'},
    {'servicename': 'MyMinesOnline', 'agencyName': 'Department of Natural Resources and Mines'},
    {'servicename': 'OESR Data Smart Event Registration Fee', 'agencyName': 'Queensland Treasury'},
    {'servicename': 'PSC Data Smart Event Registration Fee', 'agencyName': 'Public Service Commission'},
    {'servicename': 'ParksQ', 'agencyName': 'Department of National Parks, Recreation, Sport and Racing'},
    {'servicename': 'Payment of Copies of Archival Records', 'agencyName': 'Queensland State Archives'},
    {'servicename': 'Planning Infringement Notices', 'agencyName': 'Department of Agriculture, Fisheries and Forestry'},
    {'servicename': 'Plumbers and Drainers', 'agencyName': 'Queensland Building and Construction Commission'},
    {'servicename': 'Pool registration', 'agencyName': 'Queensland Building and Construction Commission'},
    {'servicename': 'Primary Industries and Fisheries FutureBeef', 'agencyName': 'Department of Employment, Economic Development and Innovation'},
    {'servicename': 'Property (lot on plan) Searches', 'agencyName': 'Department of Agriculture, Fisheries and Forestry'},
    {'servicename': 'Purchase online title search', 'agencyName': 'Department of Natural Resources and Mines'},
    {'servicename': 'QCAT Minor Civil Disputes', 'agencyName': 'Qld Civil and Administrative Tribunal'},
    {'servicename': 'QGIS (formerly DDS)', 'agencyName': 'Natural Resources and Water'},
    {'servicename': 'Queensland Chief Scientist Events', 'agencyName': 'Office of the Queensland Chief Scientist'},
    {'servicename': 'Queensland Registry of Births, Deaths and Marriages', 'agencyName': 'Department of Justice and Attorney-General'},
    {'servicename': 'Queensland Surveying Information Portal', 'agencyName': 'Department of Natural Resources and Mines'},
    {'servicename': 'RFCE Court Transcripts', 'agencyName': 'Department of Justice and Attorney-General'},
    {'servicename': 'Registered Training Organisation renewal', 'agencyName': 'Department of Education, Training & Arts'},
    {'servicename': 'Right to Information', 'agencyName': 'Right to Information'},
    {'servicename': 'SARA online development applications', 'agencyName': 'Department of State Development, Infrastructure and Planning'},
    {'servicename': 'Science Delivery', 'agencyName': 'Department of Science Information Technology and Innovation'},
    {'servicename': 'Search and Copy - Magistrates Court', 'agencyName': 'Department of Justice and Attorney-General'},
    {'servicename': 'Search and Copy - Regional', 'agencyName': 'Department of Justice and Attorney-General'},
    {'servicename': 'Search and copy - Civil', 'agencyName': 'Department of Justice and Attorney-General'},
    {'servicename': 'Search of orders request', 'agencyName': 'Department of Justice and Attorney-General'},
    {'servicename': 'Stocked Impoundment Permit', 'agencyName': 'Department of Agriculture, Fisheries and Forestry'},
    {'servicename': 'Waste tracking certificates', 'agencyName': 'Department of Environment and Heritage Protection'}
  ];

  // We'll need to include the AuthHTTP method in our constructor
  constructor(
    private authHttp: AuthHttp,
    private appConfig: AppConfig
  ) {
  }

  getPaymentDetails(): Promise<IPaymentHistory> {
    return this.authHttp
      .get(this.paymentDetailsUrl)
      .toPromise()
      .then(response => response.json() as IPaymentHistory)
      .catch(this.handleError);
  }

  getServicesName() {
    return this.agencyNamesList;
  }

  private handleError(error: any) {
    log.error(error);
    return Promise.reject(error);
  }
}



// WEBPACK FOOTER //
// ./app/services/payments/payments.service.ts